var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUtilities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_utilities",
    "data-name": "icon - utilities",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_settings_input_component_24px",
    d: "M3.909,1.727a.727.727,0,1,0-1.455,0V4.636H1V9H5.364V4.636H3.909ZM6.818,11.909A2.189,2.189,0,0,0,8.273,13.96V17H9.727V13.96a2.175,2.175,0,0,0,1.455-2.051V10.455H6.818ZM1,11.909A2.189,2.189,0,0,0,2.455,13.96V17H3.909V13.96a2.189,2.189,0,0,0,1.455-2.051V10.455H1ZM15.545,4.636V1.727a.727.727,0,1,0-1.455,0V4.636H12.636V9H17V4.636ZM9.727,1.727a.727.727,0,1,0-1.455,0V4.636H6.818V9h4.364V4.636H9.727Zm2.909,10.182a2.189,2.189,0,0,0,1.455,2.051V17h1.455V13.96A2.175,2.175,0,0,0,17,11.909V10.455H12.636Z",
    transform: "translate(-1 -1)",
    fill: "#25556e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUtilities);
export default __webpack_public_path__ + "static/media/ic_utilities.4733293b28bb6e2dd815f33adeb68a49.svg";
export { ForwardRef as ReactComponent };